module.exports = __webpack_public_path__ + "static/media/handshakeW.2b9390fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/handshakeW.svg
// module id = 550
// module chunks = 0